import { createSlice } from "@reduxjs/toolkit";

export const AppAuthStatus = createSlice({
  name: "user_authentication",
  initialState: {
    value: {
      loggedIn: false,
      userRole: 2001,
      accessToken: "",
      decodeJwt: {},
      refreshToken: "",
    },
  },
  reducers: {
    log_in: (state, action) => {
      state.value = action.payload;
    },
    updateUserRole: (state, action) => {
      state.value.userRole = action.payload?.role ? action.payload?.role : 2001;
    },
    updateAccessToken: (state, action) => {
      state.value.accessToken = action.payload?.accessToken;
    },
    resetLogin: (state) => {
      state.value = {
        loggedIn: false,
        userRole: 2001,
        accessToken: "",
        decodeJwt: {},
        refreshToken: "",
      };
    },
  },
});

export const { log_in, resetLogin, updateUserRole, updateAccessToken } =
  AppAuthStatus.actions;

export default AppAuthStatus.reducer;
